/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { mapStateToPropsWrapper } from './CaptureErreurs';
import { obtenirMessage, telechargerFichier, obtenirAffaire, obtenirPrestation } from '../App_Code/API';
import { estHTML, toDate } from '../App_Code/Utils';
import Card from './Card';
import Chargement from './Chargement';
import SensCommunication from '../App_Data/SensCommunication';
import IconeBureau from '../App_Data/IconeBureau';

const Icone = ({path, couleur}) => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={25} height={25} style={{filter: "invert(1)"}}>
        <image xlinkHref={path} width={25} height={25}/>
    </svg>
);

class PageMessage extends Component {
    state = {
        Mes: this.props.location.state && this.props.location.state.Mes ? this.props.location.state.Mes : undefined,
        isNews: this.props.location.state && this.props.location.state.isNews ? this.props.location.state.isNews : false,
        Prest: '',
        affaire: undefined,
    };
    

    componentDidMount() {
        const { location, history } = this.props;
        if (!location.state || (!location.state.Mes && !location.state.NumAuto)) {
            const chemin = location.pathname.slice(1).split('/');
            history.push(chemin && chemin[0] ? `/${chemin[0]}` : '/');
            return;
        }


        const { NumAuto } = location.state;
        if (NumAuto) {
            obtenirMessage(NumAuto).then((message) => {
                this.setState({ Mes: message });
                obtenirPrestation(message.Prest).then((prest) => {
                    this.setState({ Prest: prest });
                });

                obtenirAffaire(message.NumAff).then((affaire) => {
                    this.setState({ affaire });
                });
            });
        }
    }

    render() {
        if (!this.state.Mes) return <Chargement />;

        /* Constantes */
        const {
            Mes, isNews, Prest, affaire,
        } = this.state;
        const {
            NumAff, DateSaisie, Ind1, Ind2, Util1, LsFichiers, Memo, Objet, Bureau, LibBureau, LibPrest, SensCom,
        } = Mes;
        /* Sous-titre */
        const SousTitre = NumAff ? `Affaire n°${NumAff}` : undefined;
        /* Emetteur */
        const Emetteur = (Ind1 && Ind1.Nom) || (Util1 && Util1.Nom);
        /* SensCom */
        const sensCom = SensCommunication(SensCom);
        /* Pièces jointes */
        const PJ = LsFichiers.map((fichier, i) => (
            <span key={i}>
                {i > 0 && ' | '}
                <a target="_blank" href={telechargerFichier(fichier.Token)}>
                    {fichier.Nom || `Fichier sans nom n°${i + 1}`}
                </a>
            </span>
        ));

        /* Corps du texte */
        let Texte = '';
        if (estHTML(Memo)) {
            Texte = <div dangerouslySetInnerHTML={{ __html: Memo }} />;
        } else {
            Texte = Memo.split('\n').map((item, key) => (
                <span key={key}>
                    {item}
                    <br />
                </span>
            ));
        }

        return (
            <Card>
                <div className="row d-flex align-items-center">
                    <div className="col-2 col-xl-1">
                        <IconeBureau idBureau={Bureau} taille="fa-3x" title={LibBureau} />
                    </div>  
                    <div className="col-10 col-xl-11">
                        <div className="row d-flex">
                            {Prest && Prest.Icone ?
                                    <div className="d-flex align-items-center justify-content-center align-middle" title={LibPrest} style={{ height: 28, width: 28, borderRadius: '50%', backgroundColor: Prest.Couleur }}>
                                        <Icone path={Prest.Icone} couleur={Prest.Couleur} /> {' '}
                                    </div> :
                                    <div className="dflex align-items-center justify-content-center" style={{ height: 28, width: 28, color: '#6c757d' }} title={LibPrest}>
                                        <svg width="25" height="25" viewBox="0 0 16 16" className="bi bi-question-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                            <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                                        </svg>
                                    </div>
                                }
                            <h4 className="col-11 w-100 d-inline-block text-truncate">
                                {Objet}
                            </h4>
                        </div>
                        <span className="text-muted font-italic">
                            {SousTitre}
                        </span>
                    </div>
                </div>
                <div className="mt-2">
                    <div className="row d-flex">
                        <div className="col-8">
                            {Emetteur && !isNews && (
                                <p className="mb-0">
                                    <span className="text-info">De :</span> {Emetteur}
                                </p>
                            )}
                            {Ind2 && (
                                <p className="mb-1">
                                    <span className="text-info">À :</span> {Ind2.Nom}
                                </p>
                            )}
                            <p className="text-secondary mb-0">
                                <i className={sensCom.Icone} title={sensCom.Type} /> le {toDate(DateSaisie, 'LLLL')}
                            </p>
                        </div>
                        {!isNews && (
                        <div className="col-4 d-flex justify-content-end align-items-start">
                            <Link className="ml-2 btn btn-primary align-middle" to={{ pathname: '/MaMessagerie/Repondre', state: { Mes } }} >
                                Répondre
                            </Link>
                        </div>
                        )}
                    </div>
                    <div className="row d-flex">
                        <div className="col-8">
                            {LsFichiers.length > 0 ?
                                <p className="mb-0">
                                    <i className="fas fa-paperclip" /> {PJ}
                                </p> :
                                <p className="mb-0 text-muted font-italic">
                                    <i className="fas fa-paperclip" /> Aucune pièce jointe
                                </p>
                            }
                        </div>
                        <div className="col-4 justify-content-end align-items-end">
                            {affaire && affaire.length > 1 && (
                                <Link className="float-right" to={{ pathname: '/MaMessagerie/Conversation', state: { NumAff, affaire } }} title="Voir l'historique de la conversation" >
                                    Historique de la conversation
                                </Link>
                            )}
                        </div>
                    </div>
                    <hr />
                    <blockquote>{Texte}</blockquote>
                </div>
            </Card>
        );
    }
}

function mapStateToProps({
    SynStore
}) {
    return { };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(PageMessage);



// WEBPACK FOOTER //
// ./src/components/PageMessage.js